<template>
  <v-app>
    <v-container>
      <v-row justify="center" class="mb-3">
        <v-card width="200" height="200">
          <v-layout justify-center align-center fill-height>
            <figure>
              <v-img
                height="100"
                width="100"
                :src="target.userPic"
                class="rounded-circle"
              />

              <figcaption class="text-h6 text-center">
                {{ target.userName }}
              </figcaption>
            </figure>
          </v-layout>
        </v-card>
      </v-row>
      <!-- messages="CRUSH" -->
      <v-row justify="center">
        <v-switch
          :input-value="mytoggle"
          prepend-icon="mdi-heart"
          color="pink lighten-1"
          @click="changeToggle()"
        />
      </v-row>
      <v-row justify="center">
        <div v-show="matching">
          <v-alert
            color="pink lighten-1"
            type="success"
          >
            Fooo!両思いです
          </v-alert>
        </div>
      </v-row>
      <v-row justify="center">
        <v-textarea
          v-model="message"
          solo
          name="message"
          pa-5
          label="メッセージを入力"
        />
      </v-row>
      <v-row justify="center">
        <v-btn
          type="submit"
          @click="submit"
        >
          submit
        </v-btn>
        <v-btn @click="clear">
          clear
        </v-btn>
      </v-row>
      <v-row justify="center">
        <div v-show="submitted">
          <v-alert
            color="green lighten-1"
            type="success"
          >
            保存しました
          </v-alert>
        </div>
      </v-row>
    </v-container>
  </v-app>
</template>





<script>
import db from '../firestore.js'
import firebase from 'firebase'

export default {
  name: 'SettingCrush',
  props: {
    target: { type: Object, default: () => {} },
  },
  data() {
    return {
      mytoggle: false,
      user: this.$store.state.user,
      matching: false,
      message: '',
      submitted: false,
    }
  },
  mounted() {
    // storeにcrushToの配列があれば
    if(this.user.crushTo !== undefined) {
        // その中にtargetIdが入っていれば
        if(this.user.crushTo.includes(this.target.userId)){
          this.mytoggle = true
          // マッチング確認
          if(this.user.crushFrom.includes(this.target.userId)){ 
            this.matching = true
          }          
        }
      } else {
        return
      }
  },
  // Vueインスタンスに変化があったら発動する
  updated() {

    // setTimeoutで3000ms後にsubmittedをfalseにする
    setTimeout(() => {
      this.submitted = false}
      ,3000
    )
  },
  methods: {
    changeToggle() {
      this.mytoggle = !this.mytoggle
      // console.log(this.mytoggle)
      if ( this.mytoggle ) {
        // firestore更新
        db.collection('users').doc(this.target.userId).update({
          crushFrom: firebase.firestore.FieldValue.arrayUnion(this.user.userId)
        })
        db.collection('users').doc(this.user.userId).update({
          crushTo: firebase.firestore.FieldValue.arrayUnion(this.target.userId)
        })
        // firestoreからユーザのデータを取得
        db.collection('users').doc(this.user.userId).get().then((doc) => {
          // storeとLocalstrageを更新
          this.$store.commit('userInfo', doc.data())  
          // マッチング確認
          if(doc.data().crushFrom.includes(this.target.userId)){ 
            this.matching = true
          }
        })
         
      } else {
        // firestore更新
        db.collection('users').doc(this.target.userId).update({
          crushFrom: firebase.firestore.FieldValue.arrayRemove(this.user.userId)
        })
        db.collection('users').doc(this.user.userId).update({
          crushTo: firebase.firestore.FieldValue.arrayRemove(this.target.userId)
        })
        // firestoreからユーザのデータを取得してstoreとLocalstrageを更新
        db.collection('users').doc(this.user.userId).get().then((doc) => {
          this.$store.commit('userInfo', doc.data())  
        })
        this.matching = false
      }
    },
    submit () {
      // firestore更新
      db.collection('users').doc(this.target.userId).update({
        messageFrom: firebase.firestore.FieldValue.arrayUnion(
          {"id": this.user.userId,
           "text": this.message
           }
        )});
      db.collection('users').doc(this.user.userId).update({
        messageTo: firebase.firestore.FieldValue.arrayUnion(
          {"id": this.target.userId,
           "text": this.message
           }
        )});
      this.submitted = true
      this.message = ''
    },
    clear () {
      this.message = ''
    },
  }
}
</script>
